import config from '../config';

import { setTeamToken, setAuthDetails } from '../actions/auth';

import * as Api from '../api/onboarding-api';
import * as TeamApi from '../api/teams-api';

import { handleServerError } from 'shared-services/error-service';

import * as localStorage from './local-storage-service';
import * as cookieStorage from './cookie-storage-service';
import { trackEvent, setUserTrackingProp, trackSignup } from './events-tracker-service';

import { DEFAULT_SIGNUP_PLAN, DEFAULT_LOGIN_ROUTE } from '../constants';
import { createAlert } from './alert-service';
import { browserHistory } from '../services/history';

import { isDev, isElectron } from 'services/env-service';
import { getTeamUrlFromUrl, getDomainName } from '../utils/url';

const storage = isElectron() ? localStorage : cookieStorage;

const ssoTestLogin = (teamTokens, teamUrl, ssoLogin) => {
    if (ssoLogin) {
        return true;
    }

    const team = teamTokens.find(({ team }) => team.url === teamUrl);

    if (!team || team.sso_only) {
        return false;
    }

    return true;
}

const trackLogin = () =>
    trackEvent('USER.LOGIN', {
        method: isElectron() ? 'App' : 'Web'
    });

export const signup = ({ provider, socialData, email, code, name, password, avatar, workRole, phone }) => {
    return Api[(provider ? 'ssoSignup' : 'signup')]({
            provider,
            socialData,
            email,
            code,
            name,
            password,
            avatar
        }).then(response => {
            trackSignup(response.id, name, email, provider);

            setAuthDetails({
                masterToken: response.master_token
            });

            setUserTrackingProp('nifty_referrer', window.niftyRef);
            setUserTrackingProp('workRole', workRole);
            setUserTrackingProp('phone', phone);

            return new Promise(resolve => {
                // Wait for the events tracking
                setTimeout(() => {
                    resolve(response);
                }, 150);
            });
        })
        .catch(handleServerError);
        // .then(response => {
        //     return Promise.all([
        //         plan === 'free' ? changeTeamPlan({ teamUrl: response.url, planId: 'X_Basic_Plan' }) : Promise.resolve(),
        //         setBilling(teamUrl, stripeToken)
        //     ]).then(() => response);
        // })
}

export const createTeam = ({ url, name, logo, chat_disabled, plan = DEFAULT_SIGNUP_PLAN, signup, sumoCode }) => {
    return TeamApi.createTeam({
        url,
        name,
        logo,
        chat_disabled,
        plan: plan || DEFAULT_SIGNUP_PLAN,
        signup,
        sumoCode
    }).then(response => {
        setTeamToken(url, response.token);
        setUserTrackingProp('chatDisabled', chat_disabled);
    });
}

export const login = ({ provider, socialData, email, password, teamUrl = getTeamUrlFromUrl(), chooseTeam, redirect }) => {
    if (['/signup/team', '/login'].includes(redirect)) {
        redirect = '';
    }

    return loginRequest(provider, socialData, email, password)
        .then(payload => trackLogin().then(() => payload))
        .then(({ masterToken, teamTokens, id, sso }) => {
            let selectedTeamUrl = teamUrl;

            // Check if selected team url is present in the invite tokens
            if (!teamTokens.some(({ team }) => team && team.url === teamUrl)) {
                selectedTeamUrl = null;
            }

            if (teamTokens.length === 1 || (!chooseTeam && teamTokens.length)) {
                selectedTeamUrl = teamTokens[0].team.url;
            }

            if (selectedTeamUrl && !ssoTestLogin(teamTokens, selectedTeamUrl, sso)) {
                selectedTeamUrl = null;
            }

            if (selectedTeamUrl) {
                return {
                    teamUrl: selectedTeamUrl,
                    masterToken,
                    teamTokens
                };
            }

            return chooseTeam(masterToken, teamUrl, teamTokens, id, sso).then(teamUrl => ({
                teamUrl,
                masterToken,
                teamTokens
            }));
        })
        .then(({ masterToken, teamTokens, teamUrl }) => doLogin({
            masterToken,
            teamTokens,
            teamUrl,
            redirect: redirect || DEFAULT_LOGIN_ROUTE
        }));
}

const loginRequest = (provider, socialData, email, password) =>{
    return (provider ?
        Api.ssoLogin({
            provider,
            socialData
        }) : Api.login({
            email,
            password
        })
    )
    .then(response => ({
        masterToken: response.master_token,
        teamTokens: response.team_tokens
    }))
    .catch(handleServerError);
}

export const checkInviteToken = (token, email) => {
    return Api.checkInviteToken(token)
        .then(response => {
            if (response && response.used) {
                createAlert('error', `User ${email || ''} already joined Nifty.`, {
                    duration: 7000
                });
            }
        });
}

export const doLogin = ({ masterToken, teamTokens = [], teamUrl, redirect = window.location.pathname }) => {
    const team = teamTokens.find(({ team }) => team.url === teamUrl);
    storeLoginDetails(teamUrl, masterToken, team && team.token);

    if (!isElectron()) {
        const url = ['//', teamUrl, '.', config.APP_DOMAIN];

        if (!['/signup/team', '/login'].includes(redirect)) {
            url.push(redirect);
        }

        if (isDev()) {
            window.pathname = redirect;
        } else {
            window.location = url.join('');
        }


        return;
    }

    browserHistory.push({
        pathname: '/dashboard'
    });
}

export const storeLoginDetails = (teamUrl, masterToken, teamToken) => {
    const baseDomain = getDomainName(window.location.hostname);

    setAuthDetails({ teamUrl, masterToken, teamToken });

    storage.set('sessionStart', new Date().getTime(), { domain: baseDomain, expires: 365 });
}

// const setBilling = (teamUrl, stripeToken) => {
//     if (!stripeToken) {
//         return Promise.resolve();
//     }

//     return createBillingSource(teamUrl, stripeToken)
//         .catch(error => {
//             createAlert('error', 'Your card was declined. Please contact your bank or try another card.');

//             throw 'card_error';
//         });
// }
